export const DiscoverData = [
  {
    place: 'İstanbul',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/istanbul-bg-48279.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/istanbul/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/istanbul-1639/',
    BusUrl: 'https://www.enuygun.com/otobus-bileti/istanbul/',
    CarUrl: 'https://www.enuygun.com/arac-kiralama/sehir/istanbul/',
    TravelUrl: 'https://www.enuygun.com/bilgi/istanbul-da-gezilecek-yerler-mutlaka-gorulmesi-gereken-70-yer/',
  },
  {
    place: 'İzmir',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/izmir-bg-48278.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/izmir/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/izmir-1665/',
    BusUrl: 'https://www.enuygun.com/otobus-bileti/izmir/',
    CarUrl: 'https://www.enuygun.com/arac-kiralama/sehir/izmir/',
    TravelUrl: 'https://www.enuygun.com/bilgi/izmir-de-gezilecek-yerler/',
  },
  {
    place: 'Ankara',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/ankara-bg-48280.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/ankara/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/ankara-386/',
    BusUrl: 'https://www.enuygun.com/otobus-bileti/ankara/',
    CarUrl: 'https://www.enuygun.com/arac-kiralama/sehir/ankara/',
    TravelUrl: 'https://www.enuygun.com/bilgi/ankara-da-gezilecek-yerler-mutlaka-gorulmesi-gereken-80-yer/',
  },
  {
    place: 'Bodrum',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/bodrum-bg-48281.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/bodrum/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/bodrum-745/',
    BusUrl: 'https://www.enuygun.com/otobus-bileti/bodrum/',
    CarUrl: 'https://www.enuygun.com/arac-kiralama/bolge/mugla-bodrum/',
    TravelUrl: 'https://www.enuygun.com/bilgi/bodrum-da-gezilecek-yerler/',
  },
  {
    place: 'Antalya',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/antalya-bg-48282.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/antalya/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/antalya-481/',
    BusUrl: 'https://www.enuygun.com/otobus-bileti/antalya/',
    CarUrl: 'https://www.enuygun.com/arac-kiralama/sehir/antalya/',
    TravelUrl: 'https://www.enuygun.com/bilgi/antalya-da-gezilecek-yerler/',
  },
  {
    place: 'Londra',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/londra-bg-48283.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/londra/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/londra-2114/',
    TravelUrl: 'https://www.enuygun.com/ucak-bileti/gezgin/londra-da-gezilecek-yerler/',
  },
  {
    place: 'Paris',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/paris-bg-48284.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/paris/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/paris-2734/',
    TravelUrl: 'https://www.enuygun.com/ucak-bileti/gezgin/paris-te-gezilecek-yerler/',
  },
  {
    place: 'Roma',
    bg: 'https://cdn2.enuygun.com/media/lib/uploads/image/roma-bg-48285.png',
    flightUrl: 'https://www.enuygun.com/ucak-bileti/roma/',
    HotelUrl: 'https://www.enuygun.com/otel/bolge/roma-3023/',
    TravelUrl: 'https://www.enuygun.com/ucak-bileti/gezgin/roma-da-gezilecek-yerler/',
  },
]
